import styles from "./Exercises.module.css";
import React from "react";
import ExerciseBoxes from "../../components/exerciseBoxes/ExerciseBoxes";

const Exercises = () => {
    return (
        <div className={styles.page_wrapper}>
            <div className={styles.header_wrapper}>
                <h1 className={styles.title}>
                    <span id={styles.keyword}>Exercises</span>
                </h1>
            </div>
            <div className={styles.body_wrapper}>
                <ExerciseBoxes/>
            </div>
        </div>
    );
};

export default Exercises;